
import {useState, useEffect} from 'react';
import './warehouses.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { changeDisable } from '../../../services/Cadastros/service';
import { getPermission, showMessageError } from '../../../classes/functions';

export default function Warehouses(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [codigo_armazem, setCodigo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [ativo, setAtivo] = useState('');
  const [integrates_erp, setIntegratesErp] = useState('');
  const [funcionario, setFuncionario] = useState('S');
  
  useEffect(()=> {
    async function loadWarehouses(){
      if (id) { 
        getOne(id, option);
      } else {
        setCarrying(false);
      }
    }

    loadWarehouses();

  }, []);

  function validForm() {
    if ((codigo_armazem !== '') && (descricao !== '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();

    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    const data = {
      row: {
        codigo_armazem: codigo_armazem,
        descricao: descricao,
        integrates_erp: integrates_erp,
        tipo_funcionario: funcionario,
        ativo: ativo
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/warehouses/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/warehouses');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/warehouses/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/warehouses');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/warehouses/getList?id=" + id)
    .then((response) => {
        setCodigo(response.data.row.codigo_armazem);
        setDescricao(response.data.row.descricao);
        setAtivo(response.data.row.ativo);
        setIntegratesErp(response.data.row.integrates_erp);
        setFuncionario(response.data.row.tipo_funcionario);
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
    
    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/warehouses');
  }

  function remove(){
    api.delete("/api/warehouses/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/warehouses');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Armazéns">
          <Link to="/warehouses">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Código</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Código" value={codigo_armazem} onChange={ (e) => setCodigo(e.target.value) } disabled={view} maxLength="2"/>
                </div>
                <div className="formDiv">
                  <label>Descrição</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Descrição" value={descricao} onChange={ (e) => setDescricao(e.target.value) } disabled={view} maxLength="20"/>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Ativo</label><br/>
                  <select value={ativo} onChange={ (e) => setAtivo(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                <div className="formDiv">
                  <label>Integra ERP</label><br/>
                  <select value={integrates_erp} onChange={ (e) => setIntegratesErp(e.target.value) } disabled={view}>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                <div className="formDiv">
                  <label>Funcionário</label><br/>
                  <select value={funcionario} onChange={ (e) => setFuncionario(e.target.value) } disabled={view}>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - ARMAZENS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - ARMAZENS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}